// app/javascript/controllers/reportings_comments_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]

  connect() {
    this._timer = null
    this._pollIntervalMs = 2500

    if (this._runningRows().length > 0) this._start()
  }

  disconnect() {
    this._stop()
  }

  _start() {
    this._stop()
    this._timer = setInterval(() => this._pollAllRunning(), this._pollIntervalMs)
    this._pollAllRunning()
  }

  _stop() {
    if (this._timer) clearInterval(this._timer)
    this._timer = null
  }

  _runningRows() {
    return this.rowTargets.filter((row) => row.dataset.initialStatus === "running")
  }

  async _pollAllRunning() {
    const rows = this._runningRows()

    if (rows.length === 0) {
      this._stop()
      return
    }

    await Promise.all(rows.map((row) => this._pollRow(row)))
  }

  async _pollRow(row) {
    const url = row.dataset.statusUrl
    if (!url) return

    try {
      const resp = await fetch(url, {
        method: "GET",
        headers: { "Accept": "application/json" }
      })
      if (!resp.ok) throw new Error(await resp.text())

      const data = await resp.json()

      if (data.status === "running") return

      row.dataset.initialStatus = data.status || "idle"

      const badge = row.querySelector('[data-reportings-comments-target="runningBadge"]')

      if (badge) badge.remove()
    } catch (e) {
      console.error("[reportings-comments] poll error:", e)
    }
  }
}
